import { render, staticRenderFns } from "./UpgradeToPRO.vue?vue&type=template&id=86fef1a4&scoped=true"
import script from "./UpgradeToPRO.vue?vue&type=script&lang=js"
export * from "./UpgradeToPRO.vue?vue&type=script&lang=js"
import style0 from "./UpgradeToPRO.vue?vue&type=style&index=0&id=86fef1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fef1a4",
  null
  
)

export default component.exports